import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getPriceAvailabilityRequestByOfferId } from '../clients/priceAvailability.api';

export const priceAvailability = createQueryKeys('priceAvailability', {
    byOfferId: (offerId: string) => ({
        queryKey: [offerId],
        queryFn: () => getPriceAvailabilityRequestByOfferId(offerId),
    }),
});
